@if (isUserMessage()) {
  <div class="flex gap-2">
    <div
      class="flex justify-center items-center w-6 h-6 font-semibold text-xs rounded-full bg-yellow-500 uppercase text-neutral-900 flex-shrink-0 self-center"
    >
      {{ userInitials }}
    </div>
    <div class="flex flex-col gap-2 flex-auto min-w-0">
      <div
        class="bg-neutral-700 rounded-2xl text-sm text-white word-wrap py-2 px-3 whitespace-pre-wrap hyphens-auto w-fit"
      >
        @if (message().executionPlanAction) {
          <flx-ai-msg-action-card [action]="message().executionPlanAction" />
        } @else {
          <ng-container *ngTemplateOutlet="msg; context: { $implicit: message().message }" />
        }
        <flx-ai-msg-file-preview [files]="loadedAttachedFiles()" />
      </div>

      @if (dmSummary(); as summary) {
        <flx-ai-dm-summary
          [rows]="summary.rows"
          [isActiveOutcome]="isActiveOutcomeMessage()"
          (rowsUpdate)="onDmRowsUpdate($event)"
        />
      }
    </div>

    @if (canShowCopyToChatButton()) {
      <div class="flex justify-center items-center">
        <button
          [disabled]="!isCopyMessageAllowed()"
          [pTooltip]="copyTextToChatTooltip()"
          (click)="copyToChatInputField()"
          class="w-7 h-7 flex justify-center items-center border border-neutral-700 rounded"
          tooltipPosition="left"
        >
          <flx-icon
            [name]="copyTextToChatIcon()"
            class="text-neutral-400"
          ></flx-icon>
        </button>
      </div>
    }
  </div>
} @else {
  <div class="flex gap-2">
    <div class="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-900 flex-shrink-0">
      <flx-icon name="flowx-logo-white"></flx-icon>
    </div>
    <div
      class="min-w-0 flex flex-col flex-auto gap-2 text-sm text-white word-wrap whitespace-pre-wrap hyphens-auto overflow-hidden"
    >
      @if (showDocuments()) {
        <div class="flex flex-col gap-2">
          @if (message().documents.message) {
            <div>{{ message().documents.message }}</div>
          }

          <div class="flex gap-2 flex-wrap">
            @for (document of documents(); track $index) {
              <button
                [disabled]="isDocumentDisabled()"
                (click)="onContextDocumentClick(document)"
                class="border border-neutral-400 rounded-full px-3 py-1 text-xs"
              >
                {{ document.name }}
              </button>
            }
          </div>
        </div>
      }

      <ng-container *ngTemplateOutlet="msg; context: { $implicit: message().message }" />

      @if (message().generators?.summary) {
        <div class="text-neutral-300 italic text-xs">
          <ng-container
            *ngTemplateOutlet="msg; context: { $implicit: message().generators.summary }"
          />
        </div>

        <flx-ai-msg-file-generators [generators]="message().generators" />
      }

      @if (isMessageLast() && (changes()?.added?.length || changes()?.removed?.length)) {
        <flx-ai-analyst-summary
          [added]="changes().added"
          [removed]="changes().removed"
        />
      }

      @if (isMessageLast() && dependencyChanges()) {
        <flx-developer-dependency-summary
          [added]="dependencyChanges().added"
          [updated]="dependencyChanges().updated"
          [removed]="dependencyChanges().removed"
        />
      }

      @if (dmSummary(); as summary) {
        <flx-ai-dm-summary
          [rows]="summary.rows"
          [isActiveOutcome]="isActiveOutcomeMessage()"
          (rowsUpdate)="onDmRowsUpdate($event)"
        />
      }

      @if (message().sources?.length) {
        <flx-ai-msg-sources
          [sources]="message().sources"
          class="mt-4"
        />
      }

      @if (shouldShowFileActions()) {
        <flx-ai-msg-file-actions [msgActions]="msgFileActions()" />
      }

      @if (message().actions?.assignPagesToUserTasks && isMessageLast()) {
        <div class="flex flex-wrap gap-2">
          <button
            (click)="onAssignPagesToUserTasksClick()"
            class="flex items-center h-8 text-xs/[18px] rounded-[8px] px-[8px] py-[4px] text-xs bg-white/[.1] gap-2"
          >
            <i class="ph ph-sparkle text-yellow-500 text-[12px]"></i>
            <span class="text-white">Assign Pages to User Tasks</span>
          </button>
        </div>
      }

      @if (destinationSelector() && isMessageLast() && !loading()) {
        <flx-ai-destination-selector [message]="message()" />
      }

      @if (showFeedback()) {
        <flx-ai-feedback-actions
          [feedback]="message().feedback"
          (sendFeedback)="submitFeedback($event)"
          class="mt-2"
        />
      }

      @if (message().enhancePlanActionsDiffAction) {
        <div class="pr-8">
          <flx-execution-plan-editor [actionsDiff]="message().enhancePlanActionsDiffAction" />
        </div>
      }
    </div>
  </div>
}

<ng-template
  #msg
  let-message
>
  <div
    [innerHTML]="message | flxAiMarkdown | async"
    [class.text-orange-500]="isErrorMessage()"
    class="markdown leading-6 whitespace-normal word-wrap hyphens-auto flex flex-col gap-[1.5rem]"
  ></div>
</ng-template>
